export default __webpack_public_path__ + "static/media/zoom-in.ede92bbe.svg";